import { z } from 'zod';

/** Every match a registered player finishes earns this, win or lose. */
export const POINTS_PER_MATCH = 20;
/** A win earns this on top. */
export const POINTS_PER_WIN = 100;

export function pointsFor(record: { wins: number; losses: number }): number {
  return (record.wins + record.losses) * POINTS_PER_MATCH + record.wins * POINTS_PER_WIN;
}

/** Rows on the leaderboard (plus the viewer's own row, if lower down). */
export const LEADERBOARD_SIZE = 50;

export const leaderboardResponseSchema = z.object({
  entries: z.array(
    z.object({
      rank: z.number().int().positive(),
      username: z.string(),
      points: z.number().int().min(0),
      isYou: z.boolean(),
    }),
  ),
});
export type LeaderboardResponse = z.infer<typeof leaderboardResponseSchema>;
